/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
} from '@gh/common-shared';

import {
  JobOrderListEstimatingCriteria,
  JobOrderListMasterInfo,
} from '../../../resources/job-order-list.model';
import { ContactDetailsDialogConfig, contactDetailsDialogRoute } from '@gh/builder-shared';
import { ContactType } from '@gh/builder-shared-data';
import { filter$ } from '@gh/rx/operators';
import { DialogService, setControlValue } from '@gh/core-ui';

@Component({
  standalone: false,
  selector: 'gh-job-order-details-top-form',
  templateUrl: 'job-order-details-top-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobOrderDetailsTopFormComponent extends AbstractSnapshotFormComponent<JobOrderListMasterInfo> {
  @Input() estimatingCriteria: JobOrderListEstimatingCriteria;

  constructor(private formStateBuilder: FormStateBuilder,
              private dialogService: DialogService) {
    super();
  }

  openContact(): void {
    this.dialogService.openWithInput(contactDetailsDialogRoute, <ContactDetailsDialogConfig>{
      contactType: ContactType.Customer,
      contactId: this.state.value.contactId,
      parentTitle: 'lbl_job',
    }).afterClosed().pipe(
      filter$(Boolean))
      .subscribe((contact: any) => {
        setControlValue(this.form.group, 'contactName', contact.name);
        this.state.value.contactId = contact.contactId;
      });
  }

  protected buildForm(snapshot: FormStateSnapshot<JobOrderListMasterInfo>): FormState<JobOrderListMasterInfo> {
    return this.formStateBuilder.buildPlain({
      snapshot,
      children: {
        id: void 0,
        jobNumber: { enabled: false },
        contactName: { enabled: false },
        siteAddress: { enabled: false },
        produceInProgress: void 0,
        isFinalized: void 0,
        isNotProceeding: void 0,
        isProceeding: { enabled: false },
        isEstimateAuthorized: { enabled: false },
        isCouncilApproved: { enabled: false },
        isFinanceApproved: { enabled: false },
        isColorSelectionSigned: { enabled: false },
        isJobScheduled: { enabled: false },
        isContractSigned: { enabled: false },
        hasInsurancePolicyNumber: { enabled: false },
      },
    });
  }
}
